export enum GemRoutes {
  Admin = "/admin",
  AdminCenterMessages = "/admin/centerMessages",
  AdminCenters = "/admin/centers",
  AdminPhoneNumbers = "/admin/phoneNumbers",
  AdminIvrUserSkills = "/admin/ivrUserSkills",
  Login = "/login"
}
